import { isSafeUrl } from 'utils/urlHelpers';

/**
 * Resolve which purchase complete promo banners should be visible.
 * @param {object} features - Whitelabel feature flags.
 * @param {object} env - Whitelabel environment variables.
 * @returns {{ busTracker: boolean, accommodation: boolean }} Visibility flags per banner.
 */
export default function getPurchaseCompleteBannersVisibility(features, env) {
  return {
    busTracker: Boolean(features.BUS_TRACKER_ENABLED && isSafeUrl(features.BUS_TRACKER_URL)),
    accommodation: Boolean(
      features.ACCOMMODATION_PROMO_ENABLED && isSafeUrl(env.accommodationWhatsappUrl),
    ),
  };
}
